import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { ProviderField } from '../../../../../../../models/provider';
import { Button } from '../../../../../../atoms/Button/Button';
import { ContentBody } from '../../../../../../atoms/ContentBody/ContentBody';
import { Footer } from '../../../../../../atoms/Footer/Footer';
import {
  ProviderInputs,
  ProviderInputsPresenterProps,
  SubmitProviderInputsPayload,
} from '../../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { commonMessages } from '../../../../../../atoms/CommonMessages/messages';
import { H1 } from '../../../../../../atoms/Heading/Heading';
import { messages } from './messages';

export type SupplementalScreenProps = {
  fields: ProviderField[];
  onSubmit: (values: SubmitProviderInputsPayload) => void;
};

type TestOverrides = {
  ProviderForm?: React.ComponentType<ProviderInputsPresenterProps>;
};

export type CheckboxViewProps = SupplementalScreenProps & TestOverrides;

export const CheckboxView = ({
  fields,
  onSubmit,
  ProviderForm = ProviderInputs,
}: CheckboxViewProps) => {
  const [submitDisabled, setSubmitDisabled] = useState(true);

  return (
    <ContentBody data-testid="checkbox-fields-template">
      <H1>
        <FormattedMessage {...messages.selectAccounts} />
      </H1>
      <ProviderForm
        providerFields={fields}
        setButtonDisabled={(disabled) => setSubmitDisabled(disabled)}
        onSubmit={onSubmit}
      >
        <Footer stickToBottom>
          <Button type="submit" color="primary" variant="contained" disabled={submitDisabled}>
            <FormattedMessage {...commonMessages.submit} />
          </Button>
        </Footer>
      </ProviderForm>
    </ContentBody>
  );
};
